export const appConfig = {

  baseUrl: 'https://start.hejvi.de/',
  ttsProvider: 'browser',   // ← 'browser' oder 'openai'

  // Base URL for the web app (used for QR code validation)
  // Multi-Frontend: window.location.hostname zur Laufzeit nutzen statt fester Domain
  webAppBaseUrl: typeof window !== 'undefined' ? window.location.hostname : 'start.hejvi.de',

  // Immer relativ — gleicher Build läuft auf start.hejvi.de, front.hejvi.de, etc.
  // OpenResty auf jedem Kundenserver proxied /api/ → api.hejvi.de (megalodon)
  apiBaseUrl: '/api',
  // HIER DIE NEUE EINSTELLUNG:
  enableModerationReview: false, // "true" schaltet die KI-Vorschläge an, "false" schaltet sie aus.

  // Sprachen, die im UI zur Auswahl stehen (Fallback wenn Backend keine zurückgibt)
  // Muss mit config.php → ui_languages übereinstimmen
  uiLanguages: ['de', 'en', 'fr', 'es', 'ru', 'ar', 'pl', 'ro', 'tr', 'hr'],

  pagination: {
    feedPerPage: 5,
    defaultPerPage: 5,
    maxPerPage: 50
  },

  // Workflow configuration
  workflow: {
    // VIDEO WORKFLOW CONTROL:
    // true  = Video plays instantly when clicked/scanned (direct play)
    // false = Shows detail page first, then user clicks to play (two-step)
    directVideoPlay: true ,
    
    // Enable progress tracking for video resume functionality
    enableProgressTracking: true,
    // If video is more than 90% played, restart from beginning
    videoResumeThreshold: 90
  }
};

export default appConfig;


